

























































































import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IDocsCategory } from "@/models/docs";

@Component({
  components: {
    "show-docs": () => import("@/components/app/global/docs/showDocs.vue")
  }
})
export default class ShowDocsPreviewModal extends Vue {
  // Props

  @Prop({ default: null })
  public categorySlug!: IDocsCategory["slug"] | null;

  @Prop({ default: null })
  public docsSlugs!: IDocsCategory["slug"][] | null;

  @Prop({ default: null })
  public docsSearchQuery!: string | null;
}
